import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Carousel, CarouselControls, CarouselNavigation, CarouselPagination, CarouselSlide } from "@cinch-labs/design-system";
import { formatNumber, useViewport } from "@cinch-labs/shared-util";
import ReviewCard from "../trustpilot-review-card/trustpilot-review-card";
import Wrapper from "../wrapper/wrapper";
import TrustpilotLogo from "./assets/trustpilot-logo.svg";
import styles from "./trustpilot-reviews.module.css";
import { Env, readFromEnv } from "@cinch-nx/environments";
import { useTrustpilotScore } from "@cinch-nx/data-trustpilot";
const carouselName = "trustpilot-carousel";
const navAriaLabels = {
    previous: "Go to previous slide",
    next: "Go to next slide"
};
const ReviewSection = ({ title , reviews , numberOfReviews , starRatingLabel  })=>{
    const { vw  } = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isDesktop = vw >= 1024;
    const starRating = useTrustpilotScore();
    const shouldShowTrustPilotScoreless = readFromEnv(Env.ShowScorelessTrustpilot) === "true";
    const shouldShowTruspilotScoreless = starRating ? shouldShowTrustPilotScoreless || starRating <= 4.2 : shouldShowTrustPilotScoreless;
    const trustpilotUrl = "/customer-reviews";
    const trustpilotSummaryText = shouldShowTruspilotScoreless ? `See our ${formatNumber(numberOfReviews)} reviews on` : `Rated ${starRatingLabel} | ${formatNumber(numberOfReviews)} reviews`;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        "data-testid": "trustpilotReviews",
        className: {
            container: styles.root
        },
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: styles.reviewsTitle,
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                children: isDesktop ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.trustPilotReviewsDesktopWrapper,
                            children: reviews.map((review)=>/*#__PURE__*/ _jsx(ReviewCard, {
                                    ...review
                                }, review.title))
                        }),
                        /*#__PURE__*/ _jsxs("a", {
                            href: trustpilotUrl,
                            className: styles.trustPilotLink,
                            target: "_blank",
                            rel: "noreferrer",
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    className: styles["trustpilotLinkText"],
                                    children: trustpilotSummaryText
                                }),
                                /*#__PURE__*/ _jsx(TrustpilotLogo, {
                                    className: styles.logo,
                                    role: "img"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Carousel, {
                            customClassNames: {
                                wrapper: styles.carouselWrapper
                            },
                            name: carouselName,
                            children: reviews.map((review, idx)=>/*#__PURE__*/ _jsx(CarouselSlide, {
                                    children: /*#__PURE__*/ _jsx(ReviewCard, {
                                        ...review
                                    }, review.title)
                                }, idx))
                        }),
                        /*#__PURE__*/ _jsxs(CarouselControls, {
                            customClassNames: styles.controlsWrapper,
                            children: [
                                /*#__PURE__*/ _jsx(CarouselPagination, {
                                    name: carouselName,
                                    customClassNames: styles.carouselPagination
                                }),
                                /*#__PURE__*/ _jsx(CarouselNavigation, {
                                    name: carouselName,
                                    ariaLabels: navAriaLabels,
                                    customClassNames: {
                                        prevButton: styles.carouselPrevButton,
                                        nextButton: styles.carouselNextButton
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
export default ReviewSection;
